import { TabFilterValue } from '../EntityListFilterTabs.settings';

export const getTabValue = ({ paymentFlowType, solutions }: TabFilterValue) => {
  return JSON.stringify({
    paymentFlowType,
    solutions,
  });
};
